import InstructionStatisticsPage from "@/pages/common/InstructionStatisticsPage";

const ManagerStatistics: React.FC = () => <InstructionStatisticsPage role='manager' />;

export default ManagerStatistics;
